<template>
	<div v-if="items">
		<div class="generalTableClass table-responsive-true">

			<!-- NOT FOUND ITEMS FROM EXCEL BEGIN -->
			<div class="notFoundItemsTableWrapper" v-if="notFoundItemsFromXls.length > 0">
				<div v-if="notFoundItemsFromXlsFalse">
					<b-button @click="cancelItems" style="margin: 1%" class="pull-right" variant="danger">
						{{ $t('excel-export.clear') }}
					</b-button>
					<b-button @click="downloadTableExcel" style="margin: 1%" class="pull-right" variant="success">
						{{ $t('excel-export.download-table') }}
					</b-button>
				</div>
				<b-table
					id="tableExcelDownload"
					v-if="notFoundItemsFromXlsFalse" :items="notFoundItemsFromXls" :fields="fieldsForNotFoundItems" hover="hover" striped="striped" bordered="bordered">
					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<template slot="id" slot-scope="data">
						{{ data.index + 1 }}
					</template>
					<template slot="barcode" slot-scope="data">
						{{ data.item.barcode }}
					</template>
					<template slot="multiBarcode" slot-scope="data">
						{{ data.item.multiBarcode }}
					</template>
					<template slot="termOfItem" slot-scope="data">
						{{ data.item.termOfItem }}
					</template>
					<template slot="count" slot-scope="data">
						{{ data.item.count }}
					</template>
					<template slot="incomingPriceUsd" slot-scope="data">
						{{
							data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0 |
								currency({
									symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ' '
								})
						}}
					</template>
					<template slot="actions" slot-scope="data">
						<!-- <b-link
							:key="data.index + 'edit'"
							@click="alert('you clicked')"
						>
							<i class="fa fa-pencil-square-o"></i>
						</b-link> -->
					</template>
				</b-table>
			</div>
			<!-- INCOME PRICE ITEMS FROM EXCEL END -->
			<b-button v-if="section == 'KIRIM' && dataSource.length > 0" variant="success" class="mr-2 mb-3" size="sm" @click="addButton">
				<i class="fas fa-file-upload"/> {{ $t('incomes.incomeOldPrice') }}
			</b-button>
			<download-excel v-if="section == 'KIRIM' && dataSource.length > 0" :data="itemsForIncomePriceExcel" class="btn btn-success mr-2 mb-3 btn-sm" :name="`${$t('incomes.incomeOldPrice')}.xls`">
				{{ $t('excel-export.download-template') }}
			</download-excel>
			<b-form-file accept=".xlsx, xls" v-model="file" ref="fileinput" style="display: none" @change="processFile($event)" id="fileUpload"></b-form-file>
			<b-table :items="dataSource" :fields="columns" hover="hover" striped="striped" bordered="bordered">
				<!-- EMPTY SLOT FOR TABLE -->
				<template slot="empty" slot-scope="scope">
					<h4>{{ $t('empty') }}</h4>
				</template>

				<template slot="id" slot-scope="data">
					{{ data.index + 1 }}
				</template>
				<template slot="multiBarcode" slot-scope="data">
					<span v-for="(barcode, index) in data.item.multiBarcodes" :key="`barcodes-multi-${index}`">
						<span>{{ barcode.barcode }}</span><br>
					</span>
				</template>
				<template slot="termOfItem" slot-scope="data">
					<date-picker
						v-if="editTime && section == 'KIRIM'"
						v-model="data.item.termOfItem"
						:ref="data.index + '1'"
						format="DD-MM-YYYY"
						valueType="format"
						class="move"
						lang="ru"
					></date-picker>
					<div v-else class="text-center" @click="editTime = true">{{ data.item.termOfItem ? data.item.termOfItem : '-' }}</div>
				</template>
				<template slot="color" slot-scope="data">
					{{ data.item.color }}
				</template>
				<template slot="size" slot-scope="data">
					{{ data.item.size }}
				</template>
				<template slot="realBalance" slot-scope="data">
					{{ data.item.realBalance > 0 ? data.item.realBalance : 0 }}
				</template>
				<template slot="sectorId" slot-scope="data">
					<span>{{ setSector(data.item.sectorId) }}</span>
				</template>
				<template slot="itemName" slot-scope="data">
					<span v-if="data.item.wrapped" style="color: blue;"><strong>Упаковка - </strong>{{
							data.value ? data.value.substring(0, 30) : '-'
						}}</span>
					<span v-else>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
				</template>
				<template slot="count" slot-scope="data">
					<b-form-input :ref="data.index + '1'" type="text"
								  v-if="ok && (section == 'KIRIM' || section=='KOCHIRISH' || section == 'SPISAT')"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 1)"
								  v-model.number="data.item.count" class="move" @input="checkCount(data.index,$event)">
					</b-form-input>
					<div v-else-if="section == 'KIRIM' || section=='KOCHIRISH' || section == 'SPISAT'"
						 data-toggle="tooltip" :title="$t('pricing.update')" @click="OkFunction(data.index + '1')">
						{{ data.value }} {{ data.item.unitName }}
					</div>
					<div v-else>
						{{ data.value }} {{ data.item.unitName }}
					</div>
				</template>
				<!-- <template slot="inWrapped" slot-scope="data">
					<span>{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) : 1 }}</span>
				</template>
				<template slot="inWrappedTotal" slot-scope="data">
					<span>{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) * data.item.count : data.item.count }}</span>
				</template> -->
				<template slot="incomeUsd" slot-scope="data">
					<b-form-input :ref="data.index + '2'" type="text" v-if="ok && section == 'KIRIM'"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 2)"
								  v-model="data.item.incomingPriceUsd" class="move" :disabled="data.item.wrapped">
					</b-form-input>
					<div v-else-if="section == 'KIRIM'" data-toggle="tooltip" :title="$t('pricing.update')"
						 @click="OkFunction(data.index + '2')">
						<div class="inputWidth"> {{
								data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0 |
									currency({
										symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
									})
							}}
						</div>
					</div>
					<div v-else class="inputWidth"> {{
							data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0 |
								currency({
									symbol: depCurrencyName, symbolPosition: 'back',
									thousandsSeparator: ' '
								})
						}}
					</div>
				</template>
				<template slot="newUzb" slot-scope="data">
					<b-form-input :ref="data.index + '3'" type="text"
								  v-if="ok && section == 'KIRIM' && data.item.wrapped"
								  onClick="this.setSelectionRange(0, this.value.length)"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 3)"
								  v-model="data.item.priceUzs" class="move">
					</b-form-input>
					<div v-else-if="section == 'KIRIM' && !data.item.wrapped" data-toggle="tooltip"
						 :title="$t('pricing.update')" @click="OkFunction(data.index + '3')">
						<div class="inputWidth"> {{
								data.item.priceUzs ? data.item.priceUzs : 0 | currency({
									symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ' '
								})
							}}
						</div>
					</div>
					<div class="inputWidth" v-else> {{
							(depSaleType && depSaleType === 'WHOLE') ?
								data.item.priceWholesale : data.item.priceUzs | currency({
								symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							})
						}}
					</div>
				</template>
				<!--<template slot="incomeUsd" slot-scope="data">
						<b-form-input :ref="data.index + '3'" type="text" v-if="ok"
									  @keyup.up.left.right.down="focusInput($event ,data.index, 3)"
									  onClick="this.setSelectionRange(0, this.value.length)"
									  v-model="data.item.incomingPriceUsd" class="move">
						</b-form-input>
						<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
							 @click="OkFunction(data.index + '3')">
							<div class="inputWidth"> {{data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0 |
								currency({
								symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}</div>
						</div>
					</template>-->
				<template slot="newUsd" slot-scope="data">
					<b-form-input :ref="data.index + '4'" type="text" v-if="ok"
								  @keyup.up.left.right.down="focusInput($event ,data.index, 4)"
								  onClick="this.setSelectionRange(0, this.value.length)" v-model="data.item.priceUsd"
								  class="move">
					</b-form-input>
					<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
						 @click="OkFunction(data.index + '4')">
						<div class="inputWidth"> {{
								data.item.priceUsd ? data.item.priceUsd : 0 | currency({
									symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
									thousandsSeparator: ' '
								})
							}}
						</div>
					</div>
				</template>
				<template slot="priceUsd" slot-scope="data">
					{{ data.value * data.item.count }}$ (USD)
				</template>
				<template slot="priceUzs" slot-scope="data">
					{{
						((depSaleType && depSaleType === 'WHOLE') ? data.item.priceWholesale : data.item.priceUzs) *
						data.item.count | currency({
							symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
						})
					}}
				</template>
				<template slot="itemIncomeTotal" slot-scope="data">
					{{
						data.item.incomingPriceUsd * data.item.count | currency({
							symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
						})
					}}
				</template>
				<template slot="actions" slot-scope="data">
					<b-link v-if="(section == 'KIRIM' || section == 'KOCHIRISH') && data.item.wrapped"
							:key="data.index + 'view'" variant="outline"
							@click.prevent="viewWrappedItem(data.item, data.index)">
						<i class="fa fa-eye"></i>
					</b-link><!-- <template slot="inWrapped" slot-scope="data">
				<span>{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) : 1 }}</span>
			</template>
			<template slot="inWrappedTotal" slot-scope="data">
				<span>{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) * data.item.count : data.item.count }}</span>
			</template> -->
					<b-link v-if="section == 'KIRIM'" :key="data.index + 'copy'" @click="copyItem(data.item)">
						<i class="fa fa-copy"/>
					</b-link>
					<b-link :key="data.index + 'delete'" :id="'popOverDelete'+data.index"
							@click="showConfirm(data.index)">
						<i class="fa fa-trash"></i>
					</b-link>
					<b-popover :key="data.index + 'popover'" :target="'popOverDelete'+data.index" placement="bottom"
							   :ref="'popover'+data.index" class="refDeleteConfirm inSidebar">
						<template slot="title">
							<b-button @click="closeConfirm(data.index)" class="close" aria-label="Close"
									  style="margin-left: 5px">
								<span class="d-inline-block" aria-hidden="true">&times;</span>
							</b-button>
							{{ $t('want_to_delete?') }}
						</template>

						<div>
							<div class="row mt-1">
								<div class="col-6">
									<b-button variant="outline-danger" size="sm" block
											  @click="closeConfirm(data.index)"> {{ $t('actions.no') }}
									</b-button>
								</div>
								<div class="col-6">
									<b-button variant="outline-success" size="sm" block
											  @click="remove(data.index,data.item)">{{
											$t('actions.yes')
										}}
									</b-button>
								</div>
							</div>
						</div>
					</b-popover>
				</template>
			</b-table>

			<b-modal v-model="openViewProductModal" id="modal-lg" hide-footer size="xl"
					 :title="$t('sidebar.warehouse-management.product-view')" no-close-on-backdrop no-close-on-esc>
				<!--<span>{{viewItem}}</span>-->

				<b-table class="generalTableClass" striped="striped" bordered="bordered" small="small" fixed="fixed"
						 :items="wrappedItems"
						 :fields="section == 'KIRIM' ? computedFieldsForIncome : computedFieldsForTransfer"
						 responsive="sm">
					<template slot="index" slot-scope="data">
						{{ data.index + 1 }}
					</template>
					<template slot="incomeUzs" slot-scope="data">
						<b-form-group breakpoint="lg" class="required">
							<b-input-group size="sm">
								<b-form-input :required="true" size="sm" @focus="$event.target.select()" type="number"
											  v-model.number="data.item.incomingPriceUsd" class="ml-1"
											  :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
								<b-input-group-addon>
									<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
								</b-input-group-addon>
							</b-input-group>
						</b-form-group>
					</template>
					<!-- <template slot="incomeUzs" slot-scope="data">
						{{ data.item.incomeUzs | currency({symbol: computedDepCurrencyName, fractionCount: 2,
						symbolPosition: 'back'}) }}
					</template> -->
				</b-table>
				<div v-if="section == 'KIRIM'" class="row mt-3 createRoleModalButtons justify-content-end">
					<div class="col-4">
						<b-button variant="outline-danger" size="sm" block @click="closeWrappedModal()">
							{{ $t('actions.cancel') }}
						</b-button>
					</div>
					<div class="col-4">
						<b-button variant="outline-success" size="sm" block @click="saveWrappedModal(wrappedItems)">
							{{ $t('actions.save') }}
						</b-button>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>

<script>
import {
	mapState, mapActions
} from 'vuex'
import {debug} from 'util';
import XLSX from "xlsx";

export default {
	name: 'ItemList',

	props: {
		depSaleType: {type: String},
		items: {
			type: Array,
			default: () => null
		},
		section: {
			type: String,
			default: 'KIRIM'
		},
		mode: {
			type: String,
			default: 'create',
		},
		depCurrencyName: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			file: null,
			notFoundItemsFromXlsFalse: true,
			publicPath: process.env.BASE_URL,
			currentIndex: null,
			openViewProductModal: false,
			editTime: false,
			wrappedItems: [],
			notFoundItemsFrom: [],
			excelTableFields: {
				"Спец-код": "barcode",
				"Штрихкод": "multiBarcode",
				"Количество": "count",
				"Срок годности": "termOfItem",
				"Входящая цена": "incomingPriceUsd",
				"Продажная цена": "priceUzs"
			},
			computedFieldsForIncome: [
				// {
				// 	key: 'id',
				// 	label: '№',
				// },
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'colorName',
					label: this.$t('goods.color'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'size',
					label: this.$t('goods.size'),
					'class': 'incomeItemSize',
					visible: true,
					changebale: true
				},
				{
					key: 'name',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					visible: true,
					changebale: true
				},
				{
					key: 'amount',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},

				{
					key: 'barcode',
					label: this.$t('goods.barcode'),
				},
				{
					key: 'incomeUzs',
					label: 'Цена (приход)',
					'class': 'width18',
					visible: true,
					changebale: true
				},
			],
			computedFieldsForTransfer: [
				{
					key: 'id',
					label: '№',
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'itemName',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					visible: true,
					changebale: true
				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'termOfItem',
					label: this.$t('kirim.expirationDate'),
					visible: true,
					changebale: true
				},
				{
					key: 'count',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'realBalance',
					label: this.$t('pos.inventoryQty'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'newUzb',
					label: this.section == 'KIRIM' ? this.$t('prices.item.sum-new') : 'Цена (штук)',

				},
				{
					key: 'priceUzs',
					label: this.$t('sale.sum'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					label: `${this.$t('incomes.actions')}`,
					key: 'actions',
					'class': 'table_actions',
					visible: true,
					changebale: false
				}
			],
			customCount: 1,
			// FIELDS FOR INCOME ITEMS
			fieldsForIncomeItems: [{
				key: 'id',
				label: '№',
			},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'itemName',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					visible: true,
					changebale: true
				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'termOfItem',
					label: this.$t('kirim.expirationDate' +
						''),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'count',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'incomeUsd',
					label: this.$t('prices.item.sum'),
				},
				{
					key: 'itemIncomeTotal',
					label: this.$t('money.incomeUzsTotal'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					label: `${this.$t('incomes.actions')}`,
					key: 'actions',
					'class': 'table_actions',
					visible: true,
					changebale: false
				}
			],

			fields: [
				{
					key: 'id',
					label: '№',
					'class': 'width6Percent'
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
					'class': 'text-center',
					visible: true,
					changebale: true
				},
				{
					key: 'itemName',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					visible: true,
					changebale: true
				},
				{
					key: 'regNumber',
					label: this.$t('pricing.costNumber'),
					'class': 'text-center',
					visible: true,
					changebale: true
				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'termOfItem',
					label: this.$t('kirim.expirationDate' +
						''),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'count',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'realBalance',
					label: this.$t('pos.inventoryQty'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'newUzb',
					label: this.section == 'KIRIM' ? this.$t('prices.item.sum-new') : 'Цена (штук)',

				},
				{
					key: 'priceUzs',
					label: this.$t('sale.sum'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					label: `${this.$t('incomes.actions')}`,
					key: 'actions',
					'class': 'table_actions',
					visible: true,
					changebale: false
				}

			],
			// FIELDS FOR NOT FOUND ITEMS FROM EXCEL
			fieldsForNotFoundItems: [{
				key: 'id',
				label: '№',
			},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
					'class': 'text-center',
					visible: true,
					changebale: true
				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
					'class': 'text-center',
					visible: true,
					changebale: true
				},
				{
					key: 'termOfItem',
					label: this.$t('kirim.expirationDate'),
					'class': 'text-center',
					visible: true,
					changebale: true
				},
				{
					key: 'count',
					label: this.$t('incomes.create.count'),
					'class': 'td-30 text-center',
					visible: true,
					changebale: true
				},
				{
					key: 'incomingPriceUsd',
					label: this.$t('prices.item.sum'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					label: `${this.$t('incomes.actions')}`,
					key: 'actions',
					'class': 'table_actions',
					visible: true,
					changebale: false
				}

			],
			ok: false,
		}
	},
	computed: {
		...mapState(['userDepCurrencyName']),
		...mapState('warehouse', [
			'sectors', 'notFoundItemsFromXls'
		]),
		itemsForIncomePriceExcel() {
			if (this.dataSource.length > 0) {
				if (this.section == 'KIRIM') {
					let array = [];
					let temp;
					this.dataSource.forEach(el => {
						let multiBarcode = el.multiBarcodesString[0]
						// el.multiBarcodesString.forEach(m => {
						// 	multiBarcode += ` ${m}`
						// })
						temp = Object.assign(
							{},
							{
								"Спец-код": el.barcode,
								"Штрих-код": multiBarcode,
								"Срок годности": el.termOfItem,
								"Цена (приход)": el.incomingPriceUsd
							}
						);
						array.push(temp);
					});
					return array;
				}
			}
		},
		computedDepCurrencyName() {
			return this.depCurrencyName || this.userDepCurrencyName;
		},
		dataSource() {
			return this.items;
		},
		columns() {
			if (this.section == 'KIRIM') {
				return this.fieldsForIncomeItems;
			} else if (this.section == 'KOCHIRISH') {
				return this.computedFieldsForTransfer
			} else {
				return this.fields;
			}
		},
		hasWrappedItem() {
			if (this.items) {
				let foundIndex = this.items.findIndex(el => el.wrapped == true);
				if (foundIndex > -1) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}
	},
	methods: {
		downloadTableExcel() {
			let fileName = 'Приходные ошибочные товары.xlsx'
			let arr = this.notFoundItemsFromXls.map(e => {
				return {
					"Спец-код": e.barcode,
					"Штрихкод": e.multiBarcode,
					"Количество": e.count,
					"Срок годности": e.termOfItem,
					"Входящая цена": e.incomingPriceUsd,
					"Продажная цена": e.priceUzs
				}
			})
			let ws = XLSX.utils.json_to_sheet(arr)
			let wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, ws, 'test')
			XLSX.writeFile(wb, fileName)
		},
		addButton() {
			document.querySelector("#fileUpload").click()
		},
		processFile(event) {
			this.file = event.target.files ? event.target.files[0] : null;
			if (this.file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					/* Parse data */
					const bstr = e.target.result;
					const wb = XLSX.read(bstr, {type: 'binary'});
					/* Get first worksheet */
					const wsname = wb.SheetNames[0];
					const ws = wb.Sheets[wsname];
					/* Convert array of arrays */
					const data = XLSX.utils.sheet_to_json(ws, {header: 1});

					data.forEach((e, index) => {
						let multiBarcode = e[1],
							barcode = e[0],
							termOfItem = e[2],
							price = e[3]
						this.items.forEach((i, index) => {
							i.multiBarcodesString.forEach(b => {
								if (i.barcode == barcode && b == multiBarcode && i.termOfItem == termOfItem) {
									this.$set(i, 'incomingPriceUsd', price)
								}
							})
						})
					})
				}
				reader.readAsBinaryString(this.file);
			}
		},
		async cancelItems() {
			await this.$store.commit('warehouse/clearNotFoundItemsFromXls')
		},
		getWrappedItemsAmount(wrappedItems) {
			let inWrappedAmount = 0;
			if (wrappedItems) {
				wrappedItems.forEach(item => inWrappedAmount += item.amount)
			}
			return inWrappedAmount;
		},
		saveWrappedModal(wrappedItems) {
			this.dataSource[this.currentIndex].incomingPriceUsd = 0;
			wrappedItems.forEach(el => {
				if (el.incomingPriceUsd) {
					this.dataSource[this.currentIndex].incomingPriceUsd += el.incomingPriceUsd > 0 ? el.incomingPriceUsd * el.amount : 0;
				}
			})
			this.openViewProductModal = false;
		},
		closeWrappedModal() {
			this.openViewProductModal = false;
		},
		viewWrappedItem(item, index) {
			this.currentIndex = index;
			this.wrappedItems = item.wrappedItems ? item.wrappedItems : [];
			this.openViewProductModal = true;
		},
		setSector(sectorId) {
			if (sectorId) {
				let temp = [];
				for (let i = 0; i < this.sectors.length; i++) {
					if (sectorId === this.sectors[i].id) {
						temp = this.sectors[i].name;
					}
				}
				return temp
			} else {
				return 0
			}
		},
		async checkCount(index, $event) {
			if (this.dataSource[index].realBalance < $event && this.section !== 'KIRIM') {
				this.dataSource[index].count = await this.dataSource[index].realBalance;

				this.$vs.notify({
					title: "Количество",
					text: 'Проверьте количество товаров!',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		copyItem(item) {
			let i = Object.assign({}, item)
			i.termOfItem = null
			i.count = 0
			i.incomingPriceUsd = 0
			this.items.unshift(i)
		},
		showConfirm(index) {
			let refName = 'popover' + index;
			this.$refs[refName].$emit('open')
		},
		closeConfirm(index) {
			let refName = 'popover' + index;
			this.$refs[refName].$emit('close')
		},
		remove(index, item) {
			// let refName = 'popover' + index;
			// this.$refs[refName].$emit('close')
			this.closeConfirm(index);
			this.$emit('remove', item);
		},
		focusInput($event, index, inputOrder) {
			let lastIndex = this.dataSource.length - 1;
			if ($event.keyCode == 37) {
				if (inputOrder == 1 && index == 0) {
					return 1
				}
				if (inputOrder == 1 && index != 0) {
					const refName = (index - 1).toString() + '3'
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				if (inputOrder == 3) {
					const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				const refName = index.toString() + (parseInt(inputOrder) - 1).toString()

				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				this.$refs[refName].$el.focus()
			}
			if ($event.keyCode == 39) {
				if (inputOrder == 3 && lastIndex == index) {
					return 1
				}
				if (inputOrder == 3 && lastIndex != index) {
					const refName = (index + 1).toString() + '1'

					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				const refName = index.toString() + (parseInt(inputOrder) + 1).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}
			if ($event.keyCode == 38) {
				if (index == 0) {
					return 1
				}
				const refName = (index - 1).toString() + (inputOrder).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}
			if ($event.keyCode == 40) {
				if (index == lastIndex) {
					return 1
				}
				const refName = (index + 1).toString() + (inputOrder).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}

		},
		async OkFunction(refName) {
			await this.changeOk();
			await this.focusRef(refName)
		},
		changeOk() {
			this.ok = true;
			return true;
		},
		focusRef(refName) {
			this.$refs[refName].focus();
			this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			return true;
		},
	}
}
</script>

<style scoped>
th {
	padding: 2px;
}
</style>
